import React, { PureComponent } from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import { analyticsTrackEvent } from '../../core/analytics';
import { DOWNLOAD_DRIVER_CLICK_LINK } from '../../core/analytics/events';
import { getNativeStoreDownloadLink, getSolvAppStoreLink, getSolvPlayStoreLink } from './util';
import { isIOS, isIosApp } from '../../core/util/device';

const Link = styled.a`
  display: inline-block;
  overflow: hidden;
  background: url(${props => props.bgUrl}) no-repeat;
  background-size: contain;
  width: 135px;
  height: 40px;
`;

const AppStoreBadge = props => {
  const { campaignName, className } = props;

  const deviceIsIos = isIOS();
  const href = deviceIsIos ? getSolvAppStoreLink(campaignName) : getSolvPlayStoreLink(campaignName);
  const badgeUrl = deviceIsIos
    ? 'https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2019-07-18&kind=iossoftware&bubble=ios_apps'
    : '/images/google-play-badge.png';

  return (
    <Link
      className={className}
      bgUrl={badgeUrl}
      href={href}
      onClick={() =>
        analyticsTrackEvent(DOWNLOAD_DRIVER_CLICK_LINK, {
          campaignName: this.props.campaignName,
        })
      }
    />
  );
};

AppStoreBadge.propTypes = {
  campaignName: string,
  className: string,
};

export default AppStoreBadge;
